export const TABLE_EDIT_COMMAND_TYPE = Symbol('editCommand');
